"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemLabelFilter = exports.default = void 0;

var _autocomplete = _interopRequireWildcard(require("@clayui/autocomplete"));

var _button = require("@clayui/button");

var _form = require("@clayui/form");

var _shared = require("@clayui/shared");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _Labels = require("./Labels");

var _excluded = ["active", "allowsCustomLabel", "alignmentByViewport", "children", "clearAllTitle", "closeButtonAriaLabel", "defaultActive", "defaultItems", "defaultValue", "disabled", "disabledClearAll", "hotkeysDescription", "inputName", "inputValue", "isLoading", "isValid", "items", "liveRegion", "locator", "loadingState", "menuRenderer", "messages", "onActiveChange", "onChange", "onClearAllButtonClick", "onItemsChange", "onLoadMore", "placeholder", "size", "sourceItems", "spritemap", "value"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ClayMultiSelectInner(_ref, ref) {
  var externalActive = _ref.active,
      _ref$allowsCustomLabe = _ref.allowsCustomLabel,
      allowsCustomLabel = _ref$allowsCustomLabe === void 0 ? true : _ref$allowsCustomLabe,
      alignmentByViewport = _ref.alignmentByViewport,
      children = _ref.children,
      _ref$clearAllTitle = _ref.clearAllTitle,
      clearAllTitle = _ref$clearAllTitle === void 0 ? 'Clear All' : _ref$clearAllTitle,
      _ref$closeButtonAriaL = _ref.closeButtonAriaLabel,
      closeButtonAriaLabel = _ref$closeButtonAriaL === void 0 ? 'Remove {0}' : _ref$closeButtonAriaL,
      _ref$defaultActive = _ref.defaultActive,
      defaultActive = _ref$defaultActive === void 0 ? false : _ref$defaultActive,
      _ref$defaultItems = _ref.defaultItems,
      defaultItems = _ref$defaultItems === void 0 ? [] : _ref$defaultItems,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
      disabled = _ref.disabled,
      disabledClearAll = _ref.disabledClearAll,
      hotkeysDescription = _ref.hotkeysDescription,
      inputName = _ref.inputName,
      inputValue = _ref.inputValue,
      _i = _ref.isLoading,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? true : _ref$isValid,
      externalItems = _ref.items,
      liveRegion = _ref.liveRegion,
      _ref$locator = _ref.locator,
      locator = _ref$locator === void 0 ? {
    id: 'key',
    label: 'label',
    value: 'value'
  } : _ref$locator,
      loadingState = _ref.loadingState,
      MenuRenderer = _ref.menuRenderer,
      _ref$messages = _ref.messages,
      messages = _ref$messages === void 0 ? {
    hotkeys: 'Press backspace to delete the current row.',
    labelAdded: 'Label {0} added to the list',
    labelRemoved: 'Label {0} removed to the list',
    listCount: '{0} option available.',
    listCountPlural: '{0} options available.',
    loading: 'Loading...',
    notFound: 'No results found'
  } : _ref$messages,
      onActiveChange = _ref.onActiveChange,
      onChange = _ref.onChange,
      onClearAllButtonClick = _ref.onClearAllButtonClick,
      onItemsChange = _ref.onItemsChange,
      onLoadMore = _ref.onLoadMore,
      placeholder = _ref.placeholder,
      size = _ref.size,
      _ref$sourceItems = _ref.sourceItems,
      sourceItems = _ref$sourceItems === void 0 ? null : _ref$sourceItems,
      spritemap = _ref.spritemap,
      externalValue = _ref.value,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var containerRef = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);
  var lastChangesRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var _useControlledState = (0, _shared.useControlledState)({
    defaultName: 'defaultItems',
    defaultValue: defaultItems,
    handleName: 'onItemsChange',
    name: 'items',
    onChange: onItemsChange,
    value: externalItems
  }),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      items = _useControlledState2[0],
      setItems = _useControlledState2[1];

  var _useControlledState3 = (0, _shared.useControlledState)({
    defaultName: 'defaultValue',
    defaultValue: defaultValue,
    handleName: 'onChange',
    name: 'value',
    onChange: onChange,
    value: externalValue !== null && externalValue !== void 0 ? externalValue : inputValue
  }),
      _useControlledState4 = _slicedToArray(_useControlledState3, 2),
      value = _useControlledState4[0],
      setValue = _useControlledState4[1];

  var _useControlledState5 = (0, _shared.useControlledState)({
    defaultName: 'defaultActive',
    defaultValue: defaultActive,
    handleName: 'onActiveChange',
    name: 'active',
    onChange: onActiveChange,
    value: externalActive
  }),
      _useControlledState6 = _slicedToArray(_useControlledState5, 2),
      active = _useControlledState6[0],
      setActive = _useControlledState6[1];

  var inputElementRef = ref || inputRef;
  var ariaDescriptionId = (0, _shared.useId)();
  var hasAsyncItems = !!onLoadMore || typeof loadingState === 'number';
  var Container = MenuRenderer ? _shared.FocusScope : _react.default.Fragment;
  var containerProps = MenuRenderer ? {
    arrowKeysUpDown: false
  } : {}; // Throws the warning only when the component is mounted and avoids
  // throwing it every time a rerender happens.

  (0, _react.useEffect)(function () {
    if (MenuRenderer) {
      console.warn("<ClayMultiSelect />: You are using 'menuRenderer' which is deprecated and missing the new features and improvements that have been implemented in the component try to migrate to the new composition based API to custom list items.");
    }
  }, []);
  (0, _react.useEffect)(function () {
    // Backward compatibility with the `menuRenderer` API.
    if (MenuRenderer && sourceItems) {
      setActive(!!value && sourceItems.length !== 0);
    }
  }, [value, sourceItems]);
  var memoizedChildren = (0, _react.useCallback)(function (item) {
    if (children && typeof children === 'function') {
      var child = children(item);
      return /*#__PURE__*/_react.default.cloneElement(child, {
        onClick: function onClick(event) {
          if (child.props.onClick) {
            child.props.onClick(event);
          }

          if (event.defaultPrevented) {
            return;
          }

          event.preventDefault();
          setActive(false);
          setItems([].concat(_toConsumableArray(items), [item]));
          setValue('');
        }
      });
    }

    return /*#__PURE__*/_react.default.createElement(_autocomplete.Item, {
      key: item[locator.value],
      onClick: function onClick(event) {
        event.preventDefault();
        setActive(false);
        setItems([].concat(_toConsumableArray(items), [item]));
        setValue('');
      }
    }, item[locator.label]);
  }, [children, locator]);
  return /*#__PURE__*/_react.default.createElement(Container, containerProps, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('form-control form-control-tag-group input-group', _defineProperty({
      focus: isFocused && isValid
    }, "form-control-tag-group-".concat(size), size)),
    ref: containerRef
  }, /*#__PURE__*/_react.default.createElement(_autocomplete.Autocomplete, _extends({}, otherProps, {
    UNSAFE_loadingShrink: true,
    active: MenuRenderer ? false : active,
    allowsCustomLabel: allowsCustomLabel,
    ariaDescriptionId: ariaDescriptionId,
    as: _Labels.Labels,
    closeButtonAriaLabel: closeButtonAriaLabel,
    containerElementRef: containerRef,
    defaultItems: !hasAsyncItems ? sourceItems : undefined,
    disabled: disabled,
    filterKey: locator.label,
    inputName: inputName,
    items: hasAsyncItems ? sourceItems : undefined,
    labels: items,
    lastChangesRef: lastChangesRef,
    loadingState: loadingState,
    locator: locator,
    menuTrigger: "focus",
    messages: messages,
    onActiveChange: MenuRenderer ? function () {} : setActive,
    onChange: setValue,
    onFocus: MenuRenderer && sourceItems ? function (event) {
      if (otherProps.onFocus) {
        otherProps.onFocus(event);
      }

      setActive(!!value && sourceItems.length !== 0);
    } : otherProps.onFocus,
    onFocusChange: setIsFocused,
    onItemsChange: hasAsyncItems ? function () {} : undefined,
    onLabelsChange: setItems,
    onLoadMore: onLoadMore,
    placeholder: placeholder,
    ref: inputElementRef,
    spritemap: spritemap,
    suggestionList: sourceItems !== null && sourceItems !== void 0 ? sourceItems : [],
    value: value
  }), memoizedChildren), sourceItems && MenuRenderer && sourceItems.length > 0 && /*#__PURE__*/_react.default.createElement(_autocomplete.default.DropDown, {
    active: active,
    alignElementRef: containerRef,
    alignmentByViewport: alignmentByViewport,
    onActiveChange: setActive
  }, /*#__PURE__*/_react.default.createElement(MenuRenderer, {
    inputValue: value,
    locator: locator,
    onItemClick: function onItemClick(item) {
      setItems([].concat(_toConsumableArray(items), [item]));
      setValue('');

      if (inputElementRef.current) {
        inputElementRef.current.focus();
      }
    },
    sourceItems: sourceItems,
    value: value
  })), !disabled && !disabledClearAll && (value || items.length > 0) && /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, {
    shrink: true
  }, /*#__PURE__*/_react.default.createElement(_button.ClayButtonWithIcon, {
    "aria-label": clearAllTitle,
    borderless: true,
    className: "component-action",
    displayType: "secondary",
    onClick: function onClick() {
      if (onClearAllButtonClick) {
        onClearAllButtonClick();
      } else {
        setItems([]);
        setValue('');
      }

      if (inputElementRef.current) {
        inputElementRef.current.focus();
      }
    },
    outline: true,
    spritemap: spritemap,
    symbol: "times-circle",
    title: clearAllTitle
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "sr-only"
  }, /*#__PURE__*/_react.default.createElement("span", {
    id: ariaDescriptionId
  }, hotkeysDescription !== null && hotkeysDescription !== void 0 ? hotkeysDescription : messages.hotkeys), /*#__PURE__*/_react.default.createElement("span", {
    "aria-live": "polite",
    "aria-relevant": "text"
  }, lastChangesRef.current ? (0, _shared.sub)(liveRegion ? liveRegion[lastChangesRef.current.action] : lastChangesRef.current.action === 'added' ? messages.labelAdded : messages.labelRemoved, [lastChangesRef.current.label]) : null))));
}

ClayMultiSelectInner.displayName = 'ClayMultiSelect';
/**
 * Utility used for filtering an array of items based off the locator which
 * is set to `label` by default.
 * @deprecated since v3.95.2 - it is no longer necessary...
 */

var itemLabelFilter = function itemLabelFilter(items, _value) {
  var _locator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'label';

  return items;
};

exports.itemLabelFilter = itemLabelFilter;

var ClayMultiSelect = /*#__PURE__*/_react.default.forwardRef(ClayMultiSelectInner);

ClayMultiSelect.Item = _autocomplete.Item;
var _default = ClayMultiSelect;
exports.default = _default;